import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import type { i18n as II18n } from 'i18next';

import { getDateShortWithoutYearFormat } from './localeUtils';

dayjs.extend(utc);
dayjs.extend(customParseFormat);

// Financial year ends are stored as dates with this year
const FINANCIAL_YEAR_END_YEAR = 1999;

const isDateInFormat = (str: string, format: string, val: dayjs.Dayjs) => {
  return dayjs(str, format).format(format) === str ? val.toDate() : false;
};

export const parseFinancialYearEnd = (str: string): Date | null | false => {
  if (!str) {
    return null;
  }
  const format = getDateShortWithoutYearFormat();
  const val = dayjs(str, format).utc().year(FINANCIAL_YEAR_END_YEAR);
  return isDateInFormat(str, format, val);
};

export const formatFinancialYearEnd = (date: Date, i18n: II18n) => i18n.format(date, getDateShortWithoutYearFormat());
